import { render } from "./DetailsModal.vue?vue&type=template&id=af911f8a&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"

import "./DetailsModal.vue?vue&type=style&index=0&id=af911f8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af911f8a"]])

export default __exports__